import AsyncStorage from "@react-native-async-storage/async-storage";
// 単体パスで読む。バレル(@expo/vector-icons)経由だと使わない全アイコンセットのグリフ表
// (約430KB)が Web バンドルに同梱されるため。
import Ionicons from "@expo/vector-icons/Ionicons";
// expo-av は BGM をオンにした人だけが必要とするので、静的 import せず初回オン時に読み込む
// (Web の初期バンドルから外す。ネイティブでは同じ関数がそのまま同期的に解決される)。
let audioModulePromise = null;
const loadAudio = () => {
  if (!audioModulePromise) audioModulePromise = import("expo-av").then((m) => m.Audio);
  return audioModulePromise;
};
import { StatusBar } from "expo-status-bar";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Image,
  Linking,
  Platform,
  Pressable,
  SafeAreaView,
  ScrollView,
  Share,
  StyleSheet,
  Text,
  View,
} from "react-native";
import AdBanner from "./AdBanner";
import HeroImage from "./HeroImage";
// アイコンフォントの差し替え(Webのみ副作用あり)。Icon が最初に描画される前に走らせる。
import "./iconFont";
// 旧 URL(vercel.app)から運ばれてきたお気に入り・履歴・プランを、保存データを読む前に取り込む(Webのみ副作用あり)。
import "./carryOver";
import { SPOTS, getSpotDecisionInfo } from "./appData";
import { initializeMobileAds } from "./initializeAds";
import { SPOT_IMAGES } from "./spotImages";

const STORAGE_FAVORITES_KEY = "fukuoka-go:favorites";
const STORAGE_PLAN_KEY = "fukuoka-go:plan";
const STORAGE_HISTORY_KEY = "fukuoka-go:history";
const ADMIN_SPOTS_STORAGE_KEY = "fukuoka-go-spots-v1";
const ADMIN_SPOTS_DEFAULTS_KEY = "fukuoka-go-default-spots-v1";

// scripts/build-web.mjs の SITE_URL と同じ既定値・同じ環境変数を使う(Web版の静的ページと結果画面の共有URLを一致させるため)
const SITE_URL = (process.env.EXPO_PUBLIC_SITE_URL || "https://dokoiku-fukuoka.web.app").replace(/\/$/, "");
const SHARE_HASHTAG = "ドコイクFUKUOKA";

// A8.net 提携プログラム(じゃらんnet宿泊予約 / programId s00000005230001)。
// 訴求方法は「情報・ノウハウ記事」で申請。表示は必ず「PR」を明記し、リンク先はじゃらんnetの計測URL。
const JALAN_AFFILIATE_URL =
  "https://cm-12180.csolution.jp/c.neo/af/9ec.7/-/c9.html?adme_vos=afjlnpa8zzzzx00002001&url=https%3a%2f%2fwww%2ejalan%2enet%2f";

// 「遊ぶ」カテゴリに該当するスポット(既存データの派生。appData の genres は変更しない)
// インスタなどで話題になりやすい「映え」スポット(新規追加分と既存の写真映えスポット)
const PHOTO_SPOT_IDS = new Set([
  "kamado-jinja",
  "nanzoin",
  "chinkaiseki",
  "keya-no-oto",
  "munakata-taisha",
  "hiraodai",
  "yame-chaen",
  "raizan-sennyoji",
  "sanren-suisha",
  "shinoguri-forest",
  "kawachi-fujien",
  "miyajidake",
  "sarakurayama",
  "tsunoshima",
  "itoshima",
  "itoshima-cafe",
  "shiraito",
  "nokonoshima",
  "hyuganami",
  "kurokawa-onsen",
  "nakasu-yatai",
  "fukuoka-tower",
  "momochi-dinner",
  "mojiko-retro",
  "kego-keyaki",
  "acros-fukuoka",
]);

const PLAY_SPOT_IDS = new Set([
  "science-museum",
  "marine-world",
  "fantasy-kids",
  "guruguruya",
  "kidzania-like",
  "zoo",
  "biopark",
  "huis",
  "boss-ezo",
  "lalaport",
  "island-city-park",
  "nakanoshima-park",
  "choon-falls",
  "uminonakamichi",
]);

const WIZARD_QUESTIONS = [
  {
    key: "partyType",
    step: 1,
    stepLabel: "相手",
    title: "本日の同行者は?",
    icon: "person-outline",
    columns: 4,
    options: [
      { value: "solo", label: "ひとり", icon: "person-outline" },
      { value: "friends", label: "友人", icon: "people-outline" },
      { value: "couple", label: "恋人", icon: "heart-outline" },
      { value: "family", label: "家族", icon: "home-outline" },
    ],
  },
  {
    key: "activity",
    step: 2,
    stepLabel: "気分",
    title: "今日の野望は?",
    icon: "sparkles-outline",
    columns: 5,
    options: [
      { value: "food", label: "食べる", icon: "restaurant-outline" },
      { value: "shopping", label: "買い物", icon: "bag-handle-outline" },
      { value: "play", label: "遊ぶ", icon: "balloon-outline" },
      { value: "nature", label: "癒やし", icon: "cafe-outline" },
      { value: "photo", label: "映え", icon: "camera-outline" },
    ],
  },
  {
    key: "distance",
    step: 3,
    stepLabel: "距離",
    title: "どこまで行く?",
    icon: "location-outline",
    columns: 3,
    options: [
      { value: "near", label: "近場", icon: "location-outline" },
      { value: "trip", label: "遠出", icon: "train-outline" },
      { value: "either", label: "おまかせ", icon: "shuffle-outline" },
    ],
  },
];

const TAB_ITEMS = [
  { key: "home", label: "ホーム", icon: "home", iconOutline: "home-outline" },
  { key: "saved", label: "保存", icon: "bookmark", iconOutline: "bookmark-outline" },
  { key: "history", label: "履歴", icon: "time", iconOutline: "time-outline" },
];

const PRE_TRIP_CHECKLIST = [
  "保存プランを開いて、移動中も見返せる状態にする。記憶より画面のほうが頼りになります",
  "地図アプリに行き先を登録する。駅名と施設名を先に調べておけば、迷子は回避できます",
  "予約・整理券・営業状況と、帰りの交通時刻を公式情報で確認する。帰れないと物語が終わります",
  "雨のときの代替案を決めて同行者に共有する。天気は今日も気まぐれです",
];

// 進行役のひとこと。画面を開くたび・候補を引き直すたびに入れ替える
const HERO_TAGLINES = [
  "3つ選ぶだけ。あとはアプリが本気を出します。",
  "3つ選ぶだけ。悩む時間はここで終了です。",
  "3つ選ぶだけ。福岡のほうから候補が出てきます。",
  "3つ選ぶだけ。休日の運命が動き出します。",
  "3つ選ぶだけ。行き先のほうから近づいてきます。",
];

const RESULT_HEADLINES = [
  "運命が指し示したのは、こちらです。",
  "本日の主役、登場です。",
  "厳正なる抽選の結果、ここになりました。",
  "地図の上で、ここだけ光りました。",
  "アルゴリズムが全力で選びました。",
  "今日はここ、という結論が出ました。",
  "候補の中から、堂々の抜擢です。",
  "静かに、行き先が決まりました。",
];

function pickLine(lines, exclude) {
  const candidates = lines.filter((line) => line !== exclude);
  const source = candidates.length ? candidates : lines;
  return source[Math.floor(Math.random() * source.length)];
}

const ACTIVITY_LABELS = {
  food: "食べる",
  shopping: "買い物",
  play: "遊ぶ",
  nature: "癒やし",
  photo: "映え",
};

const DISTANCE_LABELS = {
  near: "近場",
  trip: "遠出",
  either: "おまかせ",
};

const PARTY_LABELS = {
  solo: "ひとり",
  friends: "友人",
  couple: "恋人",
  family: "家族",
};

function shuffle(items) {
  const next = [...items];
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

function uniqueById(items) {
  const seen = new Set();
  return items.filter((item) => {
    if (!item || seen.has(item.id)) return false;
    seen.add(item.id);
    return true;
  });
}

function getBrowserStorage() {
  if (typeof window === "undefined" || !window.localStorage) return null;
  return window.localStorage;
}

function readAdminSpotsFromBrowser() {
  const storage = getBrowserStorage();
  if (!storage) return null;

  try {
    if (!storage.getItem(ADMIN_SPOTS_DEFAULTS_KEY)) {
      storage.setItem(ADMIN_SPOTS_DEFAULTS_KEY, JSON.stringify(SPOTS));
    }

    const raw = storage.getItem(ADMIN_SPOTS_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return null;

    const defaultsById = Object.fromEntries(SPOTS.map((spot) => [spot.id, spot]));
    const usableSpots = parsed
      .filter((spot) => spot?.id && spot?.name)
      .map((spot) => {
        // 過去バージョンの既定データに含まれていた流用imageIdを引き継がない
        // (現在の既定でimageIdを持たないスポットは、保存データ側のimageIdも破棄する)
        const base = defaultsById[spot.id];
        if (spot.imageId && base && !base.imageId) {
          const { imageId, ...rest } = spot;
          return rest;
        }
        return spot;
      });
    return usableSpots.length ? usableSpots : null;
  } catch (error) {
    console.warn("Failed to load admin spots", error);
    try {
      storage.removeItem(ADMIN_SPOTS_STORAGE_KEY);
    } catch (removeError) {
      console.warn("Failed to remove broken admin spots", removeError);
    }
    return null;
  }
}

function normalizeStoredFavorites(value, spotsById = {}) {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  return value.filter((spotId) => {
    if (typeof spotId !== "string" || !spotsById[spotId] || seen.has(spotId)) return false;
    seen.add(spotId);
    return true;
  });
}

function normalizeStoredHistory(value, spotsById = {}) {
  if (!Array.isArray(value)) return [];
  const seen = new Set();
  return value
    .filter((spotId) => {
      if (typeof spotId !== "string" || !spotsById[spotId] || seen.has(spotId)) return false;
      seen.add(spotId);
      return true;
    })
    .slice(0, 30);
}

function normalizeStoredPlan(value, spotsById = {}) {
  if (!value || typeof value !== "object" || !Array.isArray(value.entries)) return null;

  const entries = value.entries
    .filter((entry) => entry && typeof entry === "object" && typeof entry.spotId === "string" && spotsById[entry.spotId])
    .map((entry, index) => ({
      key: typeof entry.key === "string" && entry.key ? entry.key : `slot-${index + 1}`,
      label: typeof entry.label === "string" && entry.label ? entry.label : `${index + 1}`,
      note: typeof entry.note === "string" ? entry.note : "",
      spotId: entry.spotId,
    }));

  if (!entries.length) return null;

  return {
    createdAt: typeof value.createdAt === "string" && value.createdAt ? value.createdAt : new Date().toISOString(),
    title: typeof value.title === "string" && value.title ? value.title : "ドコイク FUKUOKA",
    summary: typeof value.summary === "string" ? value.summary : "",
    entries,
  };
}

async function readStoredJson(key, fallback) {
  const raw = await AsyncStorage.getItem(key);
  if (!raw) return fallback;

  try {
    return JSON.parse(raw);
  } catch (error) {
    console.warn(`Failed to parse ${key}`, error);
    await AsyncStorage.removeItem(key);
    return fallback;
  }
}

function includesOption(values, option) {
  return Array.isArray(values) && values.includes(option);
}

// 実写が用意できていないスポットは、他所の写真を流用せず絵文字プレースホルダーで正直に表示する
const SPOT_PLACEHOLDER_EMOJI = {
  "yanagibashi-market": "🐟",
  "nagahama-market": "🐟",
  "karato-market": "🐟",
  "mojiko-retro": "⚓",
  "kokura-castle-town": "🏯",
  "kumamoto-castle-town": "🏯",
  "maizuru-park": "🏯",
  tsunoshima: "🌉",
  "aso-drive": "🌋",
  yufuin: "♨️",
  "beppu-onsen": "♨️",
  "kurokawa-onsen": "♨️",
  "ureshino-onsen": "♨️",
  "takeo-onsen": "♨️",
  "fukuoka-onsen": "♨️",
  "nishi-park": "🌸",
  "shinoguri-forest": "🌲",
  "island-city-park": "🌿",
  "hanabatake-park": "🌼",
  miyajidake: "⛩️",
  sarakurayama: "🌃",
  "kawachi-fujien": "🌸",
  "nakanoshima-park": "💧",
  "choon-falls": "💧",
  akizuki: "🏯",
  hyuganami: "🏞️",
  "fukuoka-parco": "🛍️",
  "kego-keyaki": "☕",
  haruyoshi: "🍶",
  "itoshima-cafe": "☕",
  "hirao-bakery": "🥐",
  "kamado-jinja": "⛩️",
  nanzoin: "🛕",
  chinkaiseki: "⛩️",
  "keya-no-oto": "🌊",
  "munakata-taisha": "⛩️",
  hiraodai: "🌾",
  "yame-chaen": "🍵",
  "raizan-sennyoji": "🍁",
  "sanren-suisha": "💧",
};

function getSpotImage(spot) {
  return SPOT_IMAGES[spot.imageId || spot.id] || null;
}

function SpotPhoto({ spot, style, imageStyle, emojiSize = 40, showLabel = false }) {
  const image = getSpotImage(spot);

  if (image) {
    return (
      <View style={style}>
        <Image
          source={image}
          style={imageStyle || styles.fillImage}
          resizeMode="cover"
          accessibilityRole="image"
          accessibilityLabel={`${spot.name}の写真`}
        />
      </View>
    );
  }

  return (
    <View
      style={[style, styles.photoPlaceholder]}
      accessibilityRole="image"
      accessibilityLabel={`${spot.name}のイメージ`}
    >
      <Text style={{ fontSize: emojiSize, lineHeight: emojiSize + 8 }}>
        {SPOT_PLACEHOLDER_EMOJI[spot.id] || "📍"}
      </Text>
      {showLabel && <Text style={styles.photoPlaceholderText}>{spot.area}</Text>}
    </View>
  );
}

function getPlanSlots(activity) {
  if (activity === "food") {
    return [
      { key: "start", label: "1軒目", note: "まずは軽く助走します" },
      { key: "main", label: "メイン", note: "本日の主役、ここで登場" },
      { key: "finish", label: "しめ", note: "最後の一手で満足度を上げる" },
    ];
  }

  if (activity === "shopping" || activity === "play" || activity === "photo") {
    return [
      { key: "morning", label: "午前", note: "動きやすい場所から静かに開幕" },
      { key: "lunch", label: "休憩", note: "ここで一旦、休戦です" },
      { key: "afternoon", label: "午後", note: "後半戦。ここが本気の時間" },
    ];
  }

  return [
    { key: "morning", label: "午前", note: "朝はゆっくり。急ぐ理由がありません" },
    { key: "afternoon", label: "午後", note: "景色に時間を溶かす区間" },
    { key: "finish", label: "帰り道", note: "帰り道にも、ひと山用意しました" },
  ];
}

function buildPlanSummary(filters) {
  return `${PARTY_LABELS[filters.partyType]}向け / ${ACTIVITY_LABELS[filters.activity]} / ${DISTANCE_LABELS[filters.distance]}`;
}

function createPlan({ current, results, favoriteSpots, filters }) {
  const slots = getPlanSlots(filters.activity);
  const preferred = uniqueById([current, ...favoriteSpots.filter((spot) => results.some((item) => item.id === spot.id))].filter(Boolean));
  const source = uniqueById([...preferred, ...shuffle(results)]);
  const selected = source.slice(0, slots.length);

  if (!selected.length) {
    return null;
  }

  const entries = slots.map((slot, index) => ({
    ...slot,
    spotId: (selected[index] || selected[selected.length - 1]).id,
  }));

  return {
    createdAt: new Date().toISOString(),
    title: `${ACTIVITY_LABELS[filters.activity]}プラン`,
    summary: buildPlanSummary(filters),
    entries,
  };
}

function getPlanSpots(plan, spotsById) {
  if (!plan) return [];
  return plan.entries.map((entry) => spotsById[entry.spotId]).filter(Boolean);
}

function buildGoogleMapsSearchUrl(spot) {
  const decisionInfo = getSpotDecisionInfo(spot);
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(decisionInfo.mapQuery)}`;
}

function buildGoogleMapsRouteUrl(plan, spotsById) {
  const planSpots = getPlanSpots(plan, spotsById);
  if (planSpots.length === 0) return null;
  if (planSpots.length === 1) return buildGoogleMapsSearchUrl(planSpots[0]);

  const origin = encodeURIComponent(getSpotDecisionInfo(planSpots[0]).mapQuery);
  const destination = encodeURIComponent(getSpotDecisionInfo(planSpots[planSpots.length - 1]).mapQuery);
  const waypoints = planSpots
    .slice(1, -1)
    .map((spot) => encodeURIComponent(getSpotDecisionInfo(spot).mapQuery))
    .join("%7C");
  const waypointQuery = waypoints ? `&waypoints=${waypoints}` : "";

  return `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}${waypointQuery}&travelmode=transit`;
}

// Web版の結果画面のみで使う共有用URL/文言。スポット静的ページ(scripts/build-spot-pages.mjs が出力する
// /spots/{id}.html)へ経路(utm)ごとに誘導し、「共有→新規流入」がどの経路から来たか後から追える形にする。
function buildSpotShareUrl(spot, { source, medium }) {
  return `${SITE_URL}/spots/${spot.id}.html?utm_source=${source}&utm_medium=${medium}&utm_campaign=spot_share`;
}

function buildSpotShareText(spot) {
  return `【ドコイク FUKUOKA】本日の行き先は「${spot.name}」に決定しました。`;
}

function buildSpotShareLinks(spot) {
  const text = buildSpotShareText(spot);
  const xUrl = buildSpotShareUrl(spot, { source: "x", medium: "social" });
  const lineUrl = buildSpotShareUrl(spot, { source: "line", medium: "social" });
  const copyUrl = buildSpotShareUrl(spot, { source: "copy", medium: "referral" });

  return {
    // Xだけハッシュタグを付ける(投稿が#ドコイクFUKUOKAで束なり、指名検索・被リンクの起点になるため)。
    // LINE/コピーは集約効果が無く本文が濁るだけなので付けない。
    x: `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${text}\n${xUrl}`)}&hashtags=${encodeURIComponent(SHARE_HASHTAG)}`,
    line: `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(lineUrl)}`,
    copyText: `${text}\n${copyUrl}`,
  };
}

// トップ用の共有リンク。結果画面はスポット1件を薦めるのに対し、こちらは「アプリそのもの」を薦める。
// 文面と遷移先は scripts/build-web.mjs の noscript 側と同じものを使う(JSを実行しない相手にも同じ導線を出すため)。
const SITE_SHARE_TEXT = "3タップで今日の行き先が決まる、福岡のおでかけアプリ「ドコイク FUKUOKA」。";

function buildSiteShareLinks() {
  const xUrl = `${SITE_URL}/?utm_source=x&utm_medium=social&utm_campaign=site_share`;
  const lineUrl = `${SITE_URL}/?utm_source=line&utm_medium=social&utm_campaign=site_share`;
  return {
    x: `https://twitter.com/intent/tweet?text=${encodeURIComponent(`${SITE_SHARE_TEXT}\n${xUrl}`)}&hashtags=${encodeURIComponent(SHARE_HASHTAG)}`,
    line: `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(lineUrl)}`,
  };
}

// トップに出す共有導線。結果画面の共有ボタン(ResultCard)と違い、こちらは実体の <a href> を出す。
// 押して開くだけの用途で、新しいタブに逃がしたほうが「選び直しに戻れない」事故が起きないため。
function SiteShareRow() {
  const links = useMemo(() => buildSiteShareLinks(), []);
  const hrefAttrs = { target: "_blank", rel: "noopener noreferrer" };

  return (
    <View style={styles.siteShare}>
      <Text style={styles.siteShareLabel}>迷っている友だちにも、そのまま渡せます</Text>
      <View style={styles.siteShareLinks}>
        <Text
          accessibilityRole="link"
          accessibilityLabel="ドコイク FUKUOKA をXで共有する"
          href={links.x}
          hrefAttrs={hrefAttrs}
          style={styles.siteShareLink}
        >
          Xで共有
        </Text>
        <Text
          accessibilityRole="link"
          accessibilityLabel="ドコイク FUKUOKA をLINEで送る"
          href={links.line}
          hrefAttrs={hrefAttrs}
          style={styles.siteShareLink}
        >
          LINEで送る
        </Text>
      </View>
    </View>
  );
}

// Web版だけに出す法務・運営者への導線。react-native-web が実体の <a> を出すので、
// 利用者だけでなく検索エンジンや広告審査からも「誰が運営しているか」に辿り着ける。
// リンク先のページは scripts/build-legal-pages.mjs がビルド時に生成する。
const WEB_FOOTER_LINKS = [
  { href: "/spots/", label: "スポット一覧" },
  { href: "/spots/no-car.html", label: "車なしで行ける" },
  { href: "/spots/day-trip.html", label: "日帰りの遠出" },
  { href: "/spots/tenjin-hakata.html", label: "天神・博多" },
  { href: "/about.html", label: "運営者情報" },
  { href: "/terms.html", label: "利用規約" },
  { href: "/privacy-policy.html", label: "プライバシーポリシー" },
  { href: "/contact.html", label: "お問い合わせ" },
];

function WebFooter() {
  return (
    <View style={styles.webFooter} accessibilityRole="contentinfo">
      <View style={styles.webFooterLinks}>
        {WEB_FOOTER_LINKS.map((link) => (
          <Text key={link.href} accessibilityRole="link" href={link.href} style={styles.webFooterLink}>
            {link.label}
          </Text>
        ))}
      </View>
      <Text style={styles.webFooterCopy}>© 株式会社ARISTA</Text>
    </View>
  );
}

function StepIndicator({ activeStep }) {
  return (
    <View style={styles.stepRow} accessibilityLabel={`ステップ${activeStep} / 3`}>
      {WIZARD_QUESTIONS.map((question, index) => (
        <React.Fragment key={question.key}>
          {index > 0 && <View style={styles.stepLine} />}
          <View style={styles.stepItem}>
            <View style={[styles.stepCircle, activeStep >= question.step && styles.stepCircleActive]}>
              <Text style={[styles.stepNumber, activeStep >= question.step && styles.stepNumberActive]}>
                {question.step}
              </Text>
            </View>
            <Text style={[styles.stepLabel, activeStep >= question.step && styles.stepLabelActive]}>
              {question.stepLabel}
            </Text>
          </View>
        </React.Fragment>
      ))}
    </View>
  );
}

function OptionCard({ option, selected, columns, onPress, questionTitle }) {
  return (
    <Pressable
      accessibilityRole="button"
      accessibilityLabel={`${questionTitle} ${option.label}`}
      accessibilityHint="この条件で候補を絞り込みます"
      accessibilityState={{ selected }}
      hitSlop={4}
      style={[
        styles.optionCard,
        columns === 3
          ? styles.optionCardThird
          : columns === 5
            ? styles.optionCardFifth
            : styles.optionCardQuarter,
        selected && styles.optionCardSelected,
      ]}
      onPress={onPress}
    >
      {selected && (
        <View style={styles.optionCheck}>
          <Ionicons name="checkmark" size={12} color={palette.navy} />
        </View>
      )}
      <Ionicons name={option.icon} size={columns === 5 ? 22 : 26} color={selected ? "#FFFFFF" : palette.navy} />
      <Text
        numberOfLines={1}
        style={[styles.optionLabel, columns === 5 && styles.optionLabelTight, selected && styles.optionLabelSelected]}
      >
        {option.label}
      </Text>
    </Pressable>
  );
}

function SpotMiniCard({ spot, isFavorite, onOpenSpot, onToggleFavorite, onOpenUrl }) {
  return (
    <View style={styles.spotMiniCard}>
      <SpotPhoto spot={spot} style={styles.spotMiniImage} emojiSize={30} />
      <View style={styles.spotMiniBody}>
        <Text style={styles.spotMiniTitle}>{spot.name}</Text>
        <Text style={styles.spotMiniMeta}>
          {spot.area} / {spot.pref}
        </Text>
        <Text numberOfLines={2} style={styles.spotMiniCopy}>
          {spot.reason}
        </Text>
        <View style={styles.spotMiniActions}>
          <Pressable
            style={styles.smallAction}
            onPress={() => onOpenSpot(spot)}
            accessibilityRole="button"
            accessibilityLabel={`${spot.name}の詳細を開く`}
            hitSlop={8}
          >
            <Text style={styles.smallActionText}>詳細</Text>
          </Pressable>
          <Pressable
            style={styles.smallGhost}
            accessibilityRole="button"
            accessibilityLabel={`${spot.name}を地図で見る`}
            accessibilityHint="Google Mapsでこの場所を開きます"
            hitSlop={8}
            onPress={() => void onOpenUrl(buildGoogleMapsSearchUrl(spot), "Google Maps search")}
          >
            <Text style={styles.smallGhostText}>地図</Text>
          </Pressable>
          <Pressable
            style={styles.smallGhost}
            onPress={() => onToggleFavorite(spot.id)}
            accessibilityRole="button"
            accessibilityLabel={`${spot.name}を${isFavorite ? "保存から解除" : "保存"}する`}
            accessibilityHint={isFavorite ? "保存した場所から外します" : "保存した場所に追加します"}
            accessibilityState={{ selected: isFavorite }}
            hitSlop={8}
          >
            <Ionicons
              name={isFavorite ? "bookmark" : "bookmark-outline"}
              size={13}
              color={isFavorite ? palette.orange : palette.sub}
            />
          </Pressable>
        </View>
      </View>
    </View>
  );
}

function RelatedSpots({ items, favorites, onOpenSpot, onToggleFavorite, onOpenUrl }) {
  if (!items.length) return null;

  return (
    <View style={styles.sectionBox}>
      <Text style={styles.sectionTitle}>同じ条件の対抗馬</Text>
      {items.map((spot) => (
        <SpotMiniCard
          key={spot.id}
          spot={spot}
          isFavorite={favorites.includes(spot.id)}
          onOpenSpot={onOpenSpot}
          onToggleFavorite={onToggleFavorite}
          onOpenUrl={onOpenUrl}
        />
      ))}
    </View>
  );
}

function ResultCard({
  current,
  favorites,
  relatedSpots,
  onBackToFilters,
  onToggleFavorite,
  onOpenSpot,
  onCreatePlan,
  onOpenUrl,
  onNotice,
}) {
  const isFavorite = favorites.includes(current.id);
  const decisionInfo = getSpotDecisionInfo(current);
  const shareLinks = useMemo(() => buildSpotShareLinks(current), [current]);
  const [linkCopied, setLinkCopied] = useState(false);

  useEffect(() => {
    if (!linkCopied) return undefined;
    const timer = setTimeout(() => setLinkCopied(false), 1800);
    return () => clearTimeout(timer);
  }, [linkCopied]);

  const handleCopyShareLink = async () => {
    try {
      if (typeof navigator === "undefined" || !navigator.clipboard || !navigator.clipboard.writeText) {
        throw new Error("Clipboard API unavailable");
      }
      await navigator.clipboard.writeText(shareLinks.copyText);
      setLinkCopied(true);
    } catch (error) {
      console.warn("Result link copy failed.", error);
      onNotice("コピーに失敗しました。表示されているURLをご自身で選択してコピーしてください。");
    }
  };

  return (
    <View style={styles.resultCard}>
      <SpotPhoto spot={current} style={styles.photoWrap} imageStyle={styles.resultPhoto} emojiSize={56} showLabel />

      <View style={styles.resultBody}>
        <View style={styles.resultTopRow}>
          <View style={styles.resultTopCopy}>
            <Text style={styles.resultName}>{current.name}</Text>
            {!!current.sublabel && <Text style={styles.resultSub}>{current.sublabel}</Text>}
            <Text style={styles.resultMeta}>
              {current.area} / {current.pref}
            </Text>
            <Text
              style={[
                styles.areaRangeBadge,
                current.pref === "福岡県" ? styles.areaRangeBadgeNear : styles.areaRangeBadgeTrip,
              ]}
            >
              {current.pref === "福岡県" ? "福岡市内・近郊" : `日帰り遠出圏（${current.pref}）`}
            </Text>
          </View>
          <Pressable
            style={[styles.favoriteBadge, isFavorite && styles.favoriteBadgeActive]}
            onPress={() => onToggleFavorite(current.id)}
            accessibilityRole="button"
            accessibilityLabel={`${current.name}を${isFavorite ? "保存から解除" : "保存"}する`}
            accessibilityHint={isFavorite ? "保存した場所から外します" : "保存した場所に追加します"}
            accessibilityState={{ selected: isFavorite }}
            hitSlop={8}
          >
            <Ionicons
              name={isFavorite ? "bookmark" : "bookmark-outline"}
              size={14}
              color={isFavorite ? palette.orange : palette.sub}
            />
            <Text style={[styles.favoriteBadgeText, isFavorite && styles.favoriteBadgeTextActive]}>
              {isFavorite ? "保存済み" : "保存"}
            </Text>
          </Pressable>
        </View>

        <Text style={styles.kicker}>推す理由はこちら</Text>
        <Text style={styles.reason}>{current.reason}</Text>

        <View style={styles.tagRow}>
          {current.tags.map((tag) => (
            <Text key={tag} style={styles.tag}>
              {tag}
            </Text>
          ))}
        </View>

        <View style={styles.decisionGrid}>
          {[
            ["料金", decisionInfo.fee],
            ["営業時間", decisionInfo.hours],
            ["所要時間", decisionInfo.duration],
            ["アクセス", decisionInfo.access],
            ["住所目安", decisionInfo.address],
            ["混雑目安", decisionInfo.crowd],
            ["雨天", decisionInfo.rainy],
          ].map(([label, value]) => (
            <View key={label} style={styles.decisionItem}>
              <Text style={styles.decisionLabel}>{label}</Text>
              <Text style={styles.decisionValue}>{value}</Text>
            </View>
          ))}
        </View>

        <View style={styles.sectionBox}>
          <Text style={styles.sectionTitle}>出発前の予習コーナー</Text>
          <Text style={styles.sectionBody}>持ち物・服装: {decisionInfo.bring}</Text>
          <Text style={styles.sectionBody}>安全・天気: {decisionInfo.safety}</Text>
          <Text style={styles.sectionBody}>現地での動き方: {decisionInfo.onsite}</Text>
          <Text style={styles.sectionBody}>予約・混雑: {decisionInfo.reservation}</Text>
          <Text style={styles.sectionBody}>最新情報: {decisionInfo.officialUrl}</Text>
        </View>

        <View style={styles.sectionBox}>
          <Text style={styles.sectionTitle}>現地でのふるまい方</Text>
          <Text style={styles.sectionBody}>{current.proposal}</Text>
        </View>

        <View style={styles.sectionBox}>
          <Text style={styles.sectionTitle}>みんなの証言</Text>
          <Text style={styles.sectionBody}>{current.review}</Text>
        </View>

        {/* A8.net提携(じゃらんnet)。訴求方法「情報・ノウハウ記事」での申請どおり、
            出発前の下調べセクションとして表示し、【PR】表記を先頭に明記する(M-20260920-001)。 */}
        <View style={styles.sectionBox}>
          <Text style={styles.sectionTitle}>【PR】宿泊・お出かけの下調べ</Text>
          <Text style={styles.sectionBody}>
            少し足を延ばすなら、周辺の宿を先に見ておくと計画が立てやすくなります。
          </Text>
          <View style={styles.linkRow}>
            <Pressable
              accessibilityRole="link"
              accessibilityLabel="じゃらんnetで周辺の宿泊施設を探す(広告)"
              accessibilityHint="じゃらんnetの宿泊予約サイトを新しいタブで開きます。提携リンクです。"
              hitSlop={8}
              style={styles.linkBtn}
              onPress={() => void onOpenUrl(JALAN_AFFILIATE_URL, "じゃらんnet(PR)")}
            >
              <Text style={styles.linkBtnText}>じゃらんnetで宿を探す</Text>
            </Pressable>
          </View>
        </View>

        <View style={styles.linkRow}>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel={`${current.name}から1日プランを作成`}
            accessibilityHint="この場所を含むマイプランを作ります"
            hitSlop={8}
            style={styles.linkBtnPrimary}
            onPress={() => onCreatePlan(current)}
          >
            <Text style={styles.linkBtnPrimaryText}>1日プランにする</Text>
          </Pressable>
          <Pressable
            accessibilityRole="link"
            accessibilityLabel={`${current.name}を地図で見る`}
            accessibilityHint="Google Mapsでこの場所を開きます"
            hitSlop={8}
            style={styles.linkBtn}
            onPress={() => void onOpenUrl(buildGoogleMapsSearchUrl(current), "Google Maps search")}
          >
            <Text style={styles.linkBtnText}>地図で見る</Text>
          </Pressable>
        </View>

        <View style={styles.linkRow}>
          <Pressable
            accessibilityRole="link"
            accessibilityLabel={`${current.name}を検索する`}
            accessibilityHint="ブラウザでこの場所を検索します"
            hitSlop={8}
            style={styles.linkBtn}
            onPress={() => void onOpenUrl(`https://www.google.com/search?q=${encodeURIComponent(current.name)}`, "Google search")}
          >
            <Text style={styles.linkBtnText}>検索する</Text>
          </Pressable>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="条件を変える"
            accessibilityHint="条件選択に戻って候補を探し直します"
            hitSlop={8}
            style={styles.linkBtn}
            onPress={onBackToFilters}
          >
            <Text style={styles.linkBtnText}>条件を変える</Text>
          </Pressable>
        </View>

        {Platform.OS === "web" && (
          <View style={styles.sectionBox}>
            <Text style={styles.sectionTitle}>今日の運命、共有できます</Text>
            <Text style={styles.sectionBody}>黙って一人で行くには、ちょっと惜しい結果です。</Text>
            <View style={styles.linkRow}>
              <Pressable
                accessibilityRole="link"
                accessibilityLabel={`${current.name}をXでシェア`}
                accessibilityHint="Xの投稿画面を新しいタブで開きます"
                hitSlop={8}
                style={styles.linkBtn}
                onPress={() => void onOpenUrl(shareLinks.x, "X share")}
              >
                <Text style={styles.linkBtnText}>Xでシェア</Text>
              </Pressable>
              <Pressable
                accessibilityRole="link"
                accessibilityLabel={`${current.name}をLINEで送る`}
                accessibilityHint="LINEの共有画面を新しいタブで開きます"
                hitSlop={8}
                style={styles.linkBtn}
                onPress={() => void onOpenUrl(shareLinks.line, "LINE share")}
              >
                <Text style={styles.linkBtnText}>LINEで送る</Text>
              </Pressable>
              <Pressable
                accessibilityRole="button"
                accessibilityLabel={`${current.name}の共有用リンクをコピー`}
                accessibilityHint="共有用の文章とリンクをクリップボードにコピーします"
                hitSlop={8}
                style={styles.linkBtn}
                onPress={() => void handleCopyShareLink()}
              >
                <Text style={styles.linkBtnText}>{linkCopied ? "コピー完了!" : "URLをコピー"}</Text>
              </Pressable>
            </View>
          </View>
        )}

        <RelatedSpots
          items={relatedSpots}
          favorites={favorites}
          onOpenSpot={onOpenSpot}
          onToggleFavorite={onToggleFavorite}
          onOpenUrl={onOpenUrl}
        />
      </View>
    </View>
  );
}

function PlanCard({ plan, spotsById, onOpenSpot, onOpenRoute, onSharePlan, onClearPlan }) {
  const [confirmingDelete, setConfirmingDelete] = useState(false);

  useEffect(() => {
    if (!confirmingDelete) return undefined;
    const timer = setTimeout(() => setConfirmingDelete(false), 3000);
    return () => clearTimeout(timer);
  }, [confirmingDelete]);

  const handleDeletePress = () => {
    if (!confirmingDelete) {
      setConfirmingDelete(true);
      return;
    }
    setConfirmingDelete(false);
    onClearPlan();
  };

  if (!plan) {
    return (
      <View style={styles.card}>
        <Text style={styles.cardTitle}>マイプラン</Text>
        <Text style={styles.emptyText}>
          ここはまだ真っ白です。気になる場所を保存してからプラン化すると、1日の回り方が一瞬で組み上がります。
        </Text>
      </View>
    );
  }

  return (
    <View style={styles.card}>
      <View style={styles.planHeaderRow}>
        <View style={styles.planHeaderCopy}>
          <Text style={styles.cardTitle}>{plan.title}</Text>
          <Text style={styles.planSummary}>{plan.summary}</Text>
          <Text style={styles.planCatch}>この順に回れば、今日はだいたい成功です。</Text>
        </View>
        <View style={styles.planHeaderActions}>
          <Pressable
            style={styles.smallAction}
            onPress={onSharePlan}
            accessibilityRole="button"
            accessibilityLabel={`${plan.title}を共有する`}
            accessibilityHint="保存したプランを共有シートで送ります"
            hitSlop={8}
          >
            <Text style={styles.smallActionText}>共有</Text>
          </Pressable>
          <Pressable
            style={[styles.smallGhost, confirmingDelete && styles.smallGhostDanger]}
            onPress={handleDeletePress}
            accessibilityRole="button"
            accessibilityLabel={confirmingDelete ? `${plan.title}の削除を確定する` : `${plan.title}を削除する`}
            accessibilityHint={confirmingDelete ? "もう一度押すと削除が確定します" : "保存したマイプランを削除します(確認あり)"}
            hitSlop={8}
          >
            <Text style={[styles.smallGhostText, confirmingDelete && styles.smallGhostDangerText]}>
              {confirmingDelete ? "本当に削除?" : "削除"}
            </Text>
          </Pressable>
        </View>
      </View>

      {plan.entries.map((entry, index) => {
        const spot = spotsById[entry.spotId];
        if (!spot) return null;

        return (
          <Pressable
            key={`${entry.key}-${spot.id}-${index}`}
            style={styles.planStep}
            onPress={() => onOpenSpot(spot)}
            accessibilityRole="button"
            accessibilityLabel={`${entry.label}、${spot.name}の詳細を開く`}
            accessibilityHint="プラン内のスポット詳細を表示します"
            hitSlop={8}
          >
            <View style={styles.planStepIndex}>
              <Text style={styles.planStepIndexText}>{index + 1}</Text>
            </View>
            <View style={styles.planStepBody}>
              <Text style={styles.planStepLabel}>{entry.label}</Text>
              <Text style={styles.planStepTitle}>{spot.name}</Text>
              <Text style={styles.planStepNote}>{entry.note}</Text>
              <Text style={styles.planStepMeta}>
                {spot.area} / {spot.pref}
              </Text>
            </View>
            <SpotPhoto spot={spot} style={styles.planStepImage} emojiSize={24} />
          </Pressable>
        );
      })}

      <View style={styles.linkRow}>
        <Pressable
          accessibilityRole="link"
          accessibilityLabel="プラン全体のルートをGoogle Mapsで見る"
          accessibilityHint="保存プランの回り順をGoogle Mapsで開きます"
          hitSlop={8}
          style={styles.linkBtnPrimary}
          onPress={onOpenRoute}
        >
          <Text style={styles.linkBtnPrimaryText}>Google Mapsでルートを見る</Text>
        </Pressable>
      </View>

      <View style={styles.preTripChecklist}>
        <Text style={styles.preTripTitle}>出発前の最終確認</Text>
        {PRE_TRIP_CHECKLIST.map((item) => (
          <View key={item} style={styles.preTripRow}>
            <Text style={styles.preTripMark}>✓</Text>
            <Text style={styles.preTripText}>{item}</Text>
          </View>
        ))}
      </View>
    </View>
  );
}

export default function App() {
  const scrollRef = useRef(null);
  const soundRef = useRef(null);
  const [stage, setStage] = useState("home");
  const [activeTab, setActiveTab] = useState("home");
  const [wizardStep, setWizardStep] = useState(1);
  const [bgmEnabled, setBgmEnabled] = useState(false);
  const [filters, setFilters] = useState({
    partyType: "solo",
    activity: "food",
    distance: "either",
  });
  const [currentSpotId, setCurrentSpotId] = useState(null);
  const [favorites, setFavorites] = useState([]);
  const [history, setHistory] = useState([]);
  const [savedPlan, setSavedPlan] = useState(null);
  const [savedDataLoaded, setSavedDataLoaded] = useState(false);
  const [spots, setSpots] = useState(SPOTS);
  const [externalActionMessage, setExternalActionMessage] = useState("");
  const [heroTagline] = useState(() => pickLine(HERO_TAGLINES));
  const [resultHeadline, setResultHeadline] = useState(() => pickLine(RESULT_HEADLINES));

  const rollResultHeadline = () => {
    setResultHeadline((prev) => pickLine(RESULT_HEADLINES, prev));
  };

  const safeOpenUrl = async (url, label = "external url") => {
    if (!url) return false;
    try {
      const canOpen = await Linking.canOpenURL(url);
      if (!canOpen) {
        setExternalActionMessage(`${label}を開けませんでした。共有文と保存プランは画面に残っています。もう一度お試しください。`);
        return false;
      }
      await Linking.openURL(url);
      setExternalActionMessage("");
      return true;
    } catch (error) {
      console.warn("External URL open failed; plan flow remains available.", error);
      setExternalActionMessage(`通信が少し迷子になりました。${label}を開けませんでした。通信状態を確認して、もう一度お試しください。`);
      return false;
    }
  };

  // プランの共有。
  // react-native-web の Share は navigator.share が無い環境(PCのFirefox/一部Safari)で
  // 必ず reject する。以前はそれを通信エラー扱いにして「通信状態を確認して…」と出していたが、
  // 実際には通信は無関係で、利用者が取れる行動を1つも案内できていなかった。
  // また共有シートを自分で閉じたとき(AbortError)まで失敗として赤い文言が出ていた。
  // ここでは「取り消した/使えない/本当に失敗した」を分けて扱う。
  const safeSharePlan = async (message) => {
    try {
      await Share.share({ message });
      setExternalActionMessage("");
      return true;
    } catch (error) {
      // 共有シートを自分で閉じた場合。失敗ではないので何も言わない。
      if (error && error.name === "AbortError") {
        setExternalActionMessage("");
        return false;
      }
      console.warn("Plan share failed; saved plan remains available.", error);
      const canShare = Platform.OS !== "web" || (typeof navigator !== "undefined" && !!navigator.share);
      if (!canShare) {
        // 共有シートが無いブラウザ。代わりにクリップボードへ入れて、貼り付けてもらう。
        try {
          if (typeof navigator === "undefined" || !navigator.clipboard || !navigator.clipboard.writeText) {
            throw new Error("Clipboard API unavailable");
          }
          await navigator.clipboard.writeText(message);
          setExternalActionMessage("このブラウザには共有シートがないため、プランをコピーしました。そのまま貼り付けて送れます。");
        } catch (copyError) {
          console.warn("Plan copy fallback failed.", copyError);
          setExternalActionMessage("このブラウザは共有に対応していません。プランは画面に残っているので、本文を選択してコピーしてください。");
        }
        return false;
      }
      setExternalActionMessage("共有が途中で引き返してきました。もう一度お試しください。プランは画面に残っています。");
      return false;
    }
  };

  const results = useMemo(() => {
    const matchesActivity = (spot) => {
      if (filters.activity === "play") return PLAY_SPOT_IDS.has(spot.id);
      if (filters.activity === "photo") return PHOTO_SPOT_IDS.has(spot.id);
      return includesOption(spot.genres, filters.activity);
    };

    const matches = (spot, { ignoreDistance = false } = {}) => {
      if (!ignoreDistance) {
        if (filters.distance === "trip" && spot.mode !== "trip") return false;
        if (filters.distance === "near" && spot.mode !== "near") return false;
      }
      if (!includesOption(spot.who, filters.partyType)) return false;
      return matchesActivity(spot);
    };

    const exact = spots.filter((spot) => matches(spot));
    if (exact.length) return exact;

    // 条件が厳しすぎて0件になったときは、無関係な場所を出さずに条件を1つずつ緩める
    const withoutDistance = spots.filter((spot) => matches(spot, { ignoreDistance: true }));
    if (withoutDistance.length) return withoutDistance;

    const byActivity = spots.filter(matchesActivity);
    return byActivity.length ? byActivity : spots.slice(0, 6);
  }, [filters, spots]);

  const spotsById = useMemo(() => Object.fromEntries(spots.map((spot) => [spot.id, spot])), [spots]);

  const current = useMemo(() => {
    if (currentSpotId && spotsById[currentSpotId]) {
      return spotsById[currentSpotId];
    }
    return null;
  }, [currentSpotId, spotsById]);

  const relatedSpots = useMemo(
    () => (current ? results.filter((item) => item.id !== current.id).slice(0, 3) : []),
    [current, results]
  );

  const favoriteSpots = useMemo(
    () => favorites.map((id) => spotsById[id]).filter(Boolean),
    [favorites, spotsById]
  );

  const historySpots = useMemo(
    () => history.map((id) => spotsById[id]).filter(Boolean),
    [history, spotsById]
  );

  useEffect(() => {
    let cancelled = false;

    async function syncAudio() {
      try {
        if (!bgmEnabled) {
          // まだ一度も鳴らしていなければ expo-av を読み込む必要すらない
          if (soundRef.current) await soundRef.current.stopAsync();
          return;
        }

        const Audio = await loadAudio();
        if (cancelled) return;
        await Audio.setAudioModeAsync({
          playsInSilentModeIOS: true,
          staysActiveInBackground: false,
          shouldDuckAndroid: true,
        });

        if (!soundRef.current) {
          const { sound } = await Audio.Sound.createAsync(require("./assets/bgm-soft-loop.wav"), {
            isLooping: true,
            volume: 0.28,
            shouldPlay: true,
          });
          soundRef.current = sound;
          // ロード中にOFFへ切り替えられていた場合は即停止する
          if (cancelled) await sound.stopAsync();
        } else {
          await soundRef.current.playAsync();
        }
      } catch (error) {
        console.warn("BGM playback failed", error);
      }
    }

    syncAudio();

    return () => {
      cancelled = true;
    };
  }, [bgmEnabled]);

  useEffect(() => {
    return () => {
      if (soundRef.current) {
        soundRef.current.unloadAsync();
      }
    };
  }, []);

  useEffect(() => {
    initializeMobileAds().catch((error) => {
      console.warn("AdMob initialization failed", error);
    });
  }, []);

  useEffect(() => {
    const adminSpots = readAdminSpotsFromBrowser();
    if (adminSpots) setSpots(adminSpots);
  }, []);

  useEffect(() => {
    async function loadSavedData() {
      try {
        const [storedFavorites, storedPlan, storedHistory] = await Promise.all([
          readStoredJson(STORAGE_FAVORITES_KEY, []),
          readStoredJson(STORAGE_PLAN_KEY, null),
          readStoredJson(STORAGE_HISTORY_KEY, []),
        ]);

        setFavorites(normalizeStoredFavorites(storedFavorites, spotsById));
        setSavedPlan(normalizeStoredPlan(storedPlan, spotsById));
        setHistory(normalizeStoredHistory(storedHistory, spotsById));
      } catch (error) {
        console.warn("Failed to load saved data", error);
        await Promise.all([
          AsyncStorage.removeItem(STORAGE_FAVORITES_KEY),
          AsyncStorage.removeItem(STORAGE_PLAN_KEY),
          AsyncStorage.removeItem(STORAGE_HISTORY_KEY),
        ]);
        setFavorites([]);
        setSavedPlan(null);
        setHistory([]);
      } finally {
        setSavedDataLoaded(true);
      }
    }

    loadSavedData();
  }, [spotsById]);

  useEffect(() => {
    if (!savedDataLoaded) return;
    AsyncStorage.setItem(STORAGE_FAVORITES_KEY, JSON.stringify(favorites)).catch((error) => {
      console.warn("Failed to save favorites", error);
    });
  }, [favorites, savedDataLoaded]);

  useEffect(() => {
    if (!savedDataLoaded) return;
    AsyncStorage.setItem(STORAGE_HISTORY_KEY, JSON.stringify(history)).catch((error) => {
      console.warn("Failed to save history", error);
    });
  }, [history, savedDataLoaded]);

  useEffect(() => {
    if (!savedDataLoaded) return;
    AsyncStorage.setItem(STORAGE_PLAN_KEY, JSON.stringify(savedPlan)).catch((error) => {
      console.warn("Failed to save plan", error);
    });
  }, [savedPlan, savedDataLoaded]);

  const scrollToTop = (animated = true) => {
    requestAnimationFrame(() => scrollRef.current?.scrollTo({ y: 0, animated }));
  };

  const pushHistory = (spotId) => {
    setHistory((prev) => [spotId, ...prev.filter((id) => id !== spotId)].slice(0, 30));
  };

  const openSpot = (spot) => {
    rollResultHeadline();
    setCurrentSpotId(spot.id);
    pushHistory(spot.id);
    setActiveTab("home");
    setStage("result");
    scrollToTop(false);
  };

  const showRandom = () => {
    const candidates = current ? results.filter((item) => item.id !== current.id) : results;
    const source = candidates.length ? candidates : results;
    const nextSpot = source[Math.floor(Math.random() * source.length)];
    if (!nextSpot) return;
    rollResultHeadline();
    setCurrentSpotId(nextSpot.id);
    pushHistory(nextSpot.id);
    setActiveTab("home");
    setStage("result");
    scrollToTop(true);
  };

  const backToFilters = () => {
    setCurrentSpotId(null);
    setStage("home");
    scrollToTop(false);
  };

  const selectTab = (tabKey) => {
    if (tabKey === "home" && activeTab === "home" && stage === "result") {
      backToFilters();
      return;
    }
    setActiveTab(tabKey);
    scrollToTop(false);
  };

  const toggleFavorite = (spotId) => {
    setFavorites((prev) => (prev.includes(spotId) ? prev.filter((id) => id !== spotId) : [spotId, ...prev]));
  };

  const updateFilter = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
    if (key === "partyType") setWizardStep((prev) => Math.max(prev, 2));
    if (key === "activity") setWizardStep(3);
    if (key === "distance") setWizardStep(3);
  };

  const createNewPlan = (seedSpot = current) => {
    const nextPlan = createPlan({
      current: seedSpot,
      results,
      favoriteSpots,
      filters,
    });

    if (!nextPlan) return;

    setSavedPlan(nextPlan);
    setActiveTab("saved");
    scrollToTop(true);
  };

  const clearPlan = () => {
    setSavedPlan(null);
  };

  const openPlanRoute = () => {
    const routeUrl = buildGoogleMapsRouteUrl(savedPlan, spotsById);
    if (routeUrl) {
      void safeOpenUrl(routeUrl, "Google Maps route");
    }
  };

  const sharePlan = async () => {
    if (!savedPlan) return;
    const routeUrl = buildGoogleMapsRouteUrl(savedPlan, spotsById);

    const lines = savedPlan.entries
      .map((entry, index) => {
        const spot = spotsById[entry.spotId];
        if (!spot) return null;
        const decisionInfo = getSpotDecisionInfo(spot);
        return [
          `${index + 1}. ${entry.label} - ${spot.name} (${spot.area})`,
          `   予算: ${decisionInfo.fee}`,
          `   住所目安: ${decisionInfo.address}`,
          `   時間: ${decisionInfo.duration} / アクセス: ${decisionInfo.access}`,
          `   雨天: ${decisionInfo.rainy} / 混雑: ${decisionInfo.crowd}`,
          `   持ち物・服装: ${decisionInfo.bring}`,
          `   安全・天気: ${decisionInfo.safety}`,
          `   現地での動き方: ${decisionInfo.onsite}`,
          `   予約・混雑: ${decisionInfo.reservation}`,
          `   最新情報: ${decisionInfo.officialUrl}`,
        ].join("\n");
      })
      .filter(Boolean);

    await safeSharePlan([
        `【ドコイク FUKUOKA】本日の1日プラン、確定しました。`,
        savedPlan.summary,
        routeUrl ? `Google Maps route: ${routeUrl}` : null,
        ...lines,
        "出発前の最終確認",
        ...PRE_TRIP_CHECKLIST.map((item) => `□ ${item}`),
      ].filter(Boolean).join("\n"));
  };

  const renderHome = () => (
    <>
      <View style={styles.hero}>
        <HeroImage />
        <View style={styles.heroScrim} />
        <View style={styles.heroTopRow}>
          <View style={styles.heroPill}>
            <Ionicons name="location-sharp" size={14} color={palette.navy} />
            <Text style={styles.heroPillText}>福岡市</Text>
          </View>
          <Text style={styles.heroBrand}>ドコイク FUKUOKA</Text>
          <View style={styles.heroIconRow}>
            <Pressable
              accessibilityRole="switch"
              accessibilityLabel="BGM切替"
              accessibilityHint={bgmEnabled ? "BGMをオフにします" : "BGMをオンにします"}
              accessibilityState={{ checked: bgmEnabled }}
              // react-native-web 0.21 は accessibilityState.checked を aria-checked へ
              // 変換しないため、role="switch" に必須の属性が欠けて axe の
              // aria-required-attr が落ちる(2026-09-06 実測 A11y 90)。明示的に渡す。
              aria-checked={bgmEnabled}
              hitSlop={8}
              style={styles.heroIconBtn}
              onPress={() => setBgmEnabled((prev) => !prev)}
            >
              <Ionicons
                name={bgmEnabled ? "musical-notes" : "musical-notes-outline"}
                size={17}
                color={bgmEnabled ? palette.orange : palette.navy}
              />
            </Pressable>
            <Pressable
              accessibilityRole="button"
              accessibilityLabel="保存した場所を開く"
              accessibilityHint="保存タブに切り替えます"
              hitSlop={8}
              style={styles.heroIconBtn}
              onPress={() => selectTab("saved")}
            >
              <Ionicons name="bookmark-outline" size={17} color={palette.navy} />
            </Pressable>
          </View>
        </View>
        <View style={styles.heroHeadline}>
          {/* Web では <h1> として出力される(検索エンジンと読み上げ環境にページの主題を伝える)
              「福岡」「おでかけ」を h1 に入れる。以前は「今日は、どこ行く?」だけで、
              地域名も何のサービスかも h1 に無く、検索側からは全国どこの話か判別できなかった
              (組織 docs/競合比較/ドコイク FUKUOKA.md。T-20260908-N20 / 2026-09-08)。
              1行に収めるため語数は増やさず、「どこ行く」を「おでかけ」で言い換えていない
              (指名検索の「どこ行く」も残す)。 */}
          <Text accessibilityRole="header" aria-level={1} style={styles.heroTitle}>福岡、今日はどこ行く?</Text>
          <Text style={styles.heroCopy}>{heroTagline}</Text>
        </View>
      </View>

      <View style={styles.wizardCard}>
        <StepIndicator activeStep={wizardStep} />

        {WIZARD_QUESTIONS.map((question) => (
          <View key={question.key} style={styles.questionBlock}>
            <View style={styles.questionHeader}>
              <Ionicons name={question.icon} size={18} color={palette.teal} />
              <Text style={styles.questionTitle}>{question.title}</Text>
            </View>
            <View style={styles.optionRow}>
              {question.options.map((option) => (
                <OptionCard
                  key={option.value}
                  option={option}
                  columns={question.columns}
                  selected={filters[question.key] === option.value}
                  questionTitle={question.title}
                  onPress={() => updateFilter(question.key, option.value)}
                />
              ))}
            </View>
          </View>
        ))}

        <Pressable
          accessibilityRole="button"
          accessibilityLabel="行き先を召喚する"
          accessibilityHint="選んだ条件に合うおすすめの場所を表示します"
          hitSlop={8}
          style={styles.mainBtn}
          onPress={showRandom}
        >
          <Text style={styles.mainBtnText}>行き先を召喚する</Text>
          <Ionicons name="arrow-forward" size={20} color="#FFFFFF" />
        </Pressable>

        {/* Web版だけ。react-native-web が実体の <a> を出すので、検索からも辿れる */}
        {Platform.OS === "web" && (
          <Text
            accessibilityRole="link"
            href="/spots/"
            style={styles.spotsLink}
          >
            自分で眺めたい人は、全84か所の一覧へ
          </Text>
        )}

        {Platform.OS === "web" && <SiteShareRow />}
      </View>
    </>
  );

  const renderResult = () => (
    <View style={styles.screenPad}>
      <Pressable
        accessibilityRole="button"
        accessibilityLabel="条件にもどる"
        accessibilityHint="条件選択画面に戻ります"
        hitSlop={8}
        style={styles.backRow}
        onPress={backToFilters}
      >
        <Ionicons name="chevron-back" size={18} color={palette.navy} />
        <Text style={styles.backRowText}>条件にもどる</Text>
      </Pressable>

      {current ? (
        <>
          <Text style={styles.resultHeadline}>{resultHeadline}</Text>
          <ResultCard
            current={current}
            favorites={favorites}
            relatedSpots={relatedSpots}
            onBackToFilters={backToFilters}
            onToggleFavorite={toggleFavorite}
            onOpenSpot={openSpot}
            onCreatePlan={createNewPlan}
            onOpenUrl={safeOpenUrl}
            onNotice={setExternalActionMessage}
          />
        </>
      ) : (
        <View style={styles.card}>
          <Text style={styles.cardTitle}>まだ何も起きていません。</Text>
          <Text style={styles.emptyText}>ホームで3つ選ぶと、ここに今日の行き先が現れます。</Text>
        </View>
      )}

      {/* Web版の広告は本文の下に置く。固定バーだとボタンの真上になり誤タップを招くため */}
      {Platform.OS === "web" && current ? <AdBanner style={styles.bannerInline} /> : null}
    </View>
  );

  const renderSaved = () => (
    <View style={styles.screenPad}>
      <Text style={styles.screenTitle}>保存</Text>
      <PlanCard
        plan={savedPlan}
        spotsById={spotsById}
        onOpenSpot={openSpot}
        onOpenRoute={openPlanRoute}
        onSharePlan={sharePlan}
        onClearPlan={clearPlan}
      />
      <View style={styles.card}>
        <View style={styles.planHeaderRow}>
          <View style={styles.planHeaderCopy}>
            <Text style={styles.cardTitle}>保存した場所</Text>
            <Text style={styles.planSummary}>ここに集めた場所だけで、1日を組み立てられます。</Text>
          </View>
          {favoriteSpots.length > 0 && (
            <Pressable
              accessibilityRole="button"
              accessibilityLabel="保存した場所からプラン作成"
              accessibilityHint="保存した場所を使ってマイプランを作ります"
              hitSlop={8}
              style={styles.smallAction}
              onPress={() => createNewPlan(null)}
            >
              <Text style={styles.smallActionText}>保存からプラン作成</Text>
            </Pressable>
          )}
        </View>
        {!favoriteSpots.length && (
          <Text style={styles.emptyText}>保存リストは現在まっさらです。おすすめ画面の「保存」から、記念すべき第一号をどうぞ。</Text>
        )}
        {favoriteSpots.map((spot) => (
          <SpotMiniCard
            key={spot.id}
            spot={spot}
            isFavorite
            onOpenSpot={openSpot}
            onToggleFavorite={toggleFavorite}
            onOpenUrl={safeOpenUrl}
          />
        ))}
      </View>
    </View>
  );

  const renderHistory = () => (
    <View style={styles.screenPad}>
      <Text style={styles.screenTitle}>履歴</Text>
      <View style={styles.card}>
        <Text style={styles.cardTitle}>最近ながめた場所</Text>
        {!historySpots.length && (
          <Text style={styles.emptyText}>履歴はまだ旅の途中です。ホームで行き先を召喚すると、ここに足跡が残ります。</Text>
        )}
        {historySpots.map((spot) => (
          <SpotMiniCard
            key={spot.id}
            spot={spot}
            isFavorite={favorites.includes(spot.id)}
            onOpenSpot={openSpot}
            onToggleFavorite={toggleFavorite}
            onOpenUrl={safeOpenUrl}
          />
        ))}
      </View>
    </View>
  );

  return (
    <SafeAreaView style={styles.safe}>
      <StatusBar style="dark" />

      {/* Web では <main> として出力される。ページに main ランドマークが1つも無いと
          読み上げ環境が「本文へ飛ぶ」を提供できず、axe の landmark-one-main が落ちる。 */}
      <ScrollView
        ref={scrollRef}
        accessibilityRole="main"
        style={styles.scrollArea}
        contentContainerStyle={styles.container}
      >
        {externalActionMessage ? <Text style={styles.noticeText}>{externalActionMessage}</Text> : null}
        {activeTab === "home" && (stage === "result" ? renderResult() : renderHome())}
        {activeTab === "saved" && renderSaved()}
        {activeTab === "history" && renderHistory()}
        {Platform.OS === "web" && <WebFooter />}
      </ScrollView>

      {activeTab === "home" && stage === "result" && (
        <View style={styles.floating}>
          <Pressable
            accessibilityRole="button"
            accessibilityLabel="もう一度、運命をまわす"
            accessibilityHint="現在の条件に合う別の候補を表示します"
            hitSlop={8}
            style={styles.subBtn}
            onPress={showRandom}
          >
            <Text style={styles.subBtnText}>もう一度、運命をまわす</Text>
          </Pressable>
        </View>
      )}

      <View style={styles.tabBar}>
        {TAB_ITEMS.map((item) => {
          const active = activeTab === item.key;
          return (
            <Pressable
              key={item.key}
              accessibilityRole="button"
              accessibilityLabel={`${item.label}タブを開く`}
              accessibilityHint={`${item.label}画面に切り替えます`}
              accessibilityState={{ selected: active }}
              hitSlop={8}
              style={styles.tabItem}
              onPress={() => selectTab(item.key)}
            >
              {active && <View style={styles.tabActiveBar} />}
              <Ionicons
                name={active ? item.icon : item.iconOutline}
                size={22}
                color={active ? palette.orange : palette.sub}
              />
              <Text style={[styles.tabLabel, active && styles.tabLabelActive]}>{item.label}</Text>
            </Pressable>
          );
        })}
      </View>

      {/* 全画面共通のバナー広告。タブバーの下＝画面の最下部に固定する（カラダ改善と同じ位置）。
          以前は「もう一度」ボタンと同じ浮きパネルに入っていて、画面の中ほどに見えていた。 */}
      {Platform.OS !== "web" && <AdBanner style={styles.bannerDock} />}
    </SafeAreaView>
  );
}

const palette = {
  bg: "#F4F6F9",
  surface: "#FFFFFF",
  navy: "#1E3358",
  ink: "#16243D",
  sub: "#667180",
  faint: "#5F6975",
  line: "#E6E9F0",
  lineSoft: "#EFF1F6",
  tint: "#F0F3F8",
  // アクセント色は白文字を載せる面と、白地に載せる文字の両方に使う。
  // 以前の #FF6B2C は白との比が 2.84 しかなく、主ボタン「行き先を召喚する」と
  // タブの選択中ラベルが WCAG AA を満たしていなかった(2026-09-06 実測 A11y 90)。
  // 白との比 4.60 まで濃くし、鮮やかさは保っている。
  orange: "#D14503",
  orangeSoft: "#FFF0E7",
  // orangeSoft(#FFF0E7)の上に置く文字用。#FFF0E7 との比 6.57。
  orangeDark: "#9A3412",
  teal: "#1F9E96",
};

const cardShadow = {
  shadowColor: "#1B2B4B",
  shadowOpacity: 0.08,
  shadowRadius: 16,
  shadowOffset: { width: 0, height: 8 },
  elevation: 4,
};

const styles = StyleSheet.create({
  safe: { flex: 1, backgroundColor: palette.bg },
  scrollArea: { flex: 1 },
  container: {
    width: "100%",
    maxWidth: 760,
    alignSelf: "center",
    paddingBottom: 24,
  },
  screenPad: {
    paddingHorizontal: 16,
    paddingTop: 16,
    gap: 14,
  },
  screenTitle: {
    fontSize: 24,
    fontWeight: "800",
    color: palette.ink,
    paddingHorizontal: 4,
  },
  noticeText: {
    fontSize: 13,
    lineHeight: 20,
    color: palette.orangeDark,
    paddingHorizontal: 20,
    paddingTop: 10,
  },

  // --- Hero ---
  hero: {
    minHeight: 320,
    justifyContent: "space-between",
    overflow: "hidden",
    backgroundColor: palette.navy,
  },
  heroScrim: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(13, 22, 38, 0.32)",
  },
  heroTopRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingTop: 14,
    gap: 8,
  },
  heroPill: {
    flexDirection: "row",
    alignItems: "center",
    gap: 4,
    backgroundColor: "rgba(255,255,255,0.95)",
    borderRadius: 999,
    paddingVertical: 7,
    paddingHorizontal: 12,
  },
  heroPillText: { color: palette.navy, fontWeight: "800", fontSize: 13 },
  heroBrand: {
    flex: 1,
    textAlign: "center",
    color: "#FFFFFF",
    fontWeight: "900",
    fontSize: 14,
    letterSpacing: 0.3,
  },
  heroIconRow: { flexDirection: "row", gap: 8 },
  heroIconBtn: {
    width: 36,
    height: 36,
    borderRadius: 18,
    backgroundColor: "rgba(255,255,255,0.95)",
    alignItems: "center",
    justifyContent: "center",
  },
  heroHeadline: {
    paddingHorizontal: 20,
    paddingBottom: 44,
  },
  heroTitle: {
    color: "#FFFFFF",
    fontSize: 34,
    lineHeight: 44,
    fontWeight: "900",
    textShadowColor: "rgba(10,16,28,0.45)",
    textShadowOffset: { width: 0, height: 2 },
    textShadowRadius: 8,
  },
  heroCopy: {
    marginTop: 6,
    color: "rgba(255,255,255,0.94)",
    fontSize: 14,
    lineHeight: 21,
    fontWeight: "600",
    textShadowColor: "rgba(10,16,28,0.45)",
    textShadowOffset: { width: 0, height: 1 },
    textShadowRadius: 6,
  },

  // --- Wizard card ---
  wizardCard: {
    marginTop: -24,
    marginHorizontal: 12,
    backgroundColor: palette.surface,
    borderRadius: 26,
    paddingHorizontal: 18,
    paddingTop: 18,
    paddingBottom: 22,
    ...cardShadow,
  },
  stepRow: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    paddingBottom: 16,
    borderBottomWidth: 1,
    borderBottomColor: palette.lineSoft,
    marginBottom: 16,
  },
  stepItem: { flexDirection: "row", alignItems: "center", gap: 7 },
  stepCircle: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 1.5,
    borderColor: palette.line,
    backgroundColor: palette.surface,
    alignItems: "center",
    justifyContent: "center",
  },
  stepCircleActive: {
    backgroundColor: palette.orange,
    borderColor: palette.orange,
  },
  stepNumber: { fontSize: 14, fontWeight: "800", color: palette.sub },
  stepNumberActive: { color: "#FFFFFF" },
  stepLabel: { fontSize: 14, fontWeight: "700", color: palette.sub },
  stepLabelActive: { color: palette.ink },
  stepLine: {
    width: 28,
    height: 1.5,
    backgroundColor: palette.line,
  },
  questionBlock: { marginBottom: 18 },
  questionHeader: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
    marginBottom: 10,
  },
  questionTitle: { fontSize: 17, fontWeight: "800", color: palette.ink },
  optionRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  optionCard: {
    alignItems: "center",
    justifyContent: "center",
    gap: 6,
    paddingVertical: 14,
    paddingHorizontal: 4,
    borderRadius: 16,
    borderWidth: 1.5,
    borderColor: palette.line,
    backgroundColor: palette.surface,
    position: "relative",
  },
  optionCardQuarter: {
    flexGrow: 1,
    flexBasis: "21%",
  },
  optionCardFifth: {
    flexGrow: 1,
    flexBasis: "16%",
    paddingHorizontal: 2,
  },
  optionCardThird: {
    flexGrow: 1,
    flexBasis: "29%",
  },
  optionCardSelected: {
    backgroundColor: palette.navy,
    borderColor: palette.navy,
  },
  optionCheck: {
    position: "absolute",
    top: 6,
    right: 6,
    width: 18,
    height: 18,
    borderRadius: 9,
    backgroundColor: "#FFFFFF",
    alignItems: "center",
    justifyContent: "center",
  },
  optionLabel: { fontSize: 13, fontWeight: "800", color: palette.ink },
  optionLabelTight: { fontSize: 11.5 },
  optionLabelSelected: { color: "#FFFFFF" },
  mainBtn: {
    marginTop: 4,
    minHeight: 58,
    borderRadius: 999,
    backgroundColor: palette.orange,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    paddingHorizontal: 24,
    shadowColor: palette.orange,
    shadowOpacity: 0.35,
    shadowRadius: 14,
    shadowOffset: { width: 0, height: 8 },
    elevation: 8,
  },
  mainBtnText: { color: "#FFFFFF", fontWeight: "900", fontSize: 20 },

  // --- Result ---
  backRow: {
    flexDirection: "row",
    alignItems: "center",
    gap: 2,
    alignSelf: "flex-start",
    paddingVertical: 6,
    paddingRight: 10,
  },
  backRowText: { color: palette.navy, fontWeight: "800", fontSize: 14 },
  resultCard: {
    backgroundColor: palette.surface,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: palette.line,
    overflow: "hidden",
    ...cardShadow,
  },
  photoWrap: {
    height: 224,
    backgroundColor: palette.tint,
  },
  resultPhoto: { width: "100%", height: "100%" },
  fillImage: { width: "100%", height: "100%" },
  photoPlaceholder: {
    backgroundColor: palette.orangeSoft,
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    gap: 4,
  },
  photoPlaceholderText: {
    fontSize: 12,
    fontWeight: "700",
    color: palette.orangeDark,
  },
  resultBody: {
    padding: 18,
  },
  resultTopRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
    alignItems: "flex-start",
  },
  resultTopCopy: {
    flex: 1,
  },
  favoriteBadge: {
    alignSelf: "flex-start",
    maxWidth: "100%",
    flexDirection: "row",
    alignItems: "center",
    gap: 5,
    borderRadius: 999,
    paddingVertical: 9,
    paddingHorizontal: 13,
    backgroundColor: palette.surface,
    borderWidth: 1,
    borderColor: palette.line,
  },
  favoriteBadgeActive: {
    backgroundColor: palette.orangeSoft,
    borderColor: palette.orange,
  },
  favoriteBadgeText: {
    color: palette.sub,
    fontWeight: "800",
    fontSize: 12,
  },
  favoriteBadgeTextActive: {
    color: palette.orangeDark,
  },
  resultHeadline: {
    fontSize: 17,
    lineHeight: 24,
    fontWeight: "800",
    color: palette.ink,
    paddingHorizontal: 4,
  },
  resultName: { fontSize: 23, lineHeight: 31, fontWeight: "800", color: palette.ink },
  resultSub: { fontSize: 13, color: palette.sub, marginTop: 4 },
  resultMeta: { fontSize: 13, color: palette.sub, marginTop: 4 },
  areaRangeBadge: {
    alignSelf: "flex-start",
    marginTop: 8,
    paddingVertical: 4,
    paddingHorizontal: 10,
    borderRadius: 999,
    overflow: "hidden",
    fontSize: 11,
    fontWeight: "800",
  },
  areaRangeBadgeNear: {
    backgroundColor: "#E4F5F3",
    color: palette.teal,
  },
  areaRangeBadgeTrip: {
    backgroundColor: "#FFEEE3",
    color: palette.orangeDark,
  },
  kicker: {
    fontSize: 11,
    fontWeight: "800",
    color: palette.orange,
    marginTop: 16,
    letterSpacing: 1.5,
  },
  reason: { fontSize: 16, lineHeight: 25, fontWeight: "700", color: palette.ink, marginTop: 6 },
  tagRow: { flexDirection: "row", flexWrap: "wrap", gap: 8, marginTop: 12 },
  tag: {
    backgroundColor: palette.tint,
    color: palette.navy,
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 999,
    overflow: "hidden",
    fontWeight: "700",
    fontSize: 12,
    lineHeight: 17,
  },
  decisionGrid: { flexDirection: "row", flexWrap: "wrap", gap: 8, marginTop: 14 },
  decisionItem: {
    flexGrow: 1,
    flexBasis: 220,
    minWidth: "47%",
    borderRadius: 14,
    backgroundColor: palette.bg,
    borderWidth: 1,
    borderColor: palette.lineSoft,
    paddingVertical: 10,
    paddingHorizontal: 12,
  },
  decisionLabel: {
    fontSize: 11,
    fontWeight: "800",
    color: palette.faint,
    letterSpacing: 0.5,
    marginBottom: 4,
  },
  decisionValue: { fontSize: 13, lineHeight: 19, fontWeight: "700", color: palette.ink },
  sectionBox: {
    marginTop: 12,
    backgroundColor: palette.bg,
    borderRadius: 14,
    padding: 14,
    borderWidth: 1,
    borderColor: palette.lineSoft,
  },
  sectionTitle: { fontSize: 14, fontWeight: "800", color: palette.ink, marginBottom: 6 },
  sectionBody: { fontSize: 14, lineHeight: 22, color: palette.sub },
  linkRow: { flexDirection: "row", flexWrap: "wrap", gap: 10, marginTop: 14 },
  linkBtn: {
    flex: 1,
    minWidth: 150,
    minHeight: 48,
    borderRadius: 999,
    paddingVertical: 13,
    paddingHorizontal: 12,
    backgroundColor: palette.tint,
    justifyContent: "center",
  },
  linkBtnText: { textAlign: "center", fontWeight: "700", color: palette.navy, lineHeight: 19 },
  linkBtnPrimary: {
    flex: 1,
    minWidth: 150,
    minHeight: 48,
    borderRadius: 999,
    paddingVertical: 13,
    paddingHorizontal: 12,
    backgroundColor: palette.orange,
    justifyContent: "center",
  },
  linkBtnPrimaryText: { textAlign: "center", fontWeight: "800", color: "#FFFFFF", lineHeight: 19 },

  // --- Cards ---
  card: {
    backgroundColor: palette.surface,
    borderRadius: 20,
    padding: 18,
    borderWidth: 1,
    borderColor: palette.line,
    ...cardShadow,
  },
  cardTitle: {
    fontSize: 19,
    lineHeight: 26,
    fontWeight: "800",
    color: palette.ink,
    marginBottom: 10,
  },
  emptyText: {
    fontSize: 14,
    lineHeight: 22,
    color: palette.sub,
  },

  // --- Mini cards ---
  spotMiniCard: {
    flexDirection: "row",
    gap: 12,
    marginTop: 12,
    backgroundColor: palette.surface,
    borderRadius: 16,
    padding: 10,
    borderWidth: 1,
    borderColor: palette.lineSoft,
  },
  spotMiniImage: {
    width: 92,
    height: 92,
    borderRadius: 12,
    backgroundColor: palette.tint,
    overflow: "hidden",
  },
  spotMiniBody: {
    flex: 1,
  },
  spotMiniTitle: {
    fontSize: 15,
    fontWeight: "800",
    color: palette.ink,
  },
  spotMiniMeta: {
    marginTop: 2,
    fontSize: 12,
    color: palette.faint,
  },
  spotMiniCopy: {
    marginTop: 5,
    fontSize: 13,
    lineHeight: 19,
    color: palette.sub,
  },
  spotMiniActions: {
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    gap: 8,
    marginTop: 8,
  },
  smallAction: {
    minHeight: 36,
    borderRadius: 999,
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: palette.navy,
    alignItems: "center",
    justifyContent: "center",
  },
  smallActionText: {
    color: "#FFFFFF",
    fontWeight: "800",
    fontSize: 12,
  },
  smallGhost: {
    minHeight: 36,
    minWidth: 36,
    borderRadius: 999,
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: palette.line,
    backgroundColor: palette.surface,
    alignItems: "center",
    justifyContent: "center",
  },
  smallGhostText: {
    color: palette.sub,
    fontWeight: "800",
    fontSize: 12,
  },
  smallGhostDanger: {
    backgroundColor: palette.orangeSoft,
    borderColor: palette.orange,
  },
  smallGhostDangerText: {
    color: palette.orangeDark,
  },

  // --- Plan ---
  planHeaderRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 12,
  },
  planHeaderCopy: {
    flex: 1,
    minWidth: 200,
  },
  planHeaderActions: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },
  planSummary: {
    fontSize: 13,
    lineHeight: 18,
    color: palette.sub,
    marginTop: 2,
  },
  planCatch: {
    fontSize: 13,
    lineHeight: 19,
    fontWeight: "700",
    color: palette.teal,
    marginTop: 6,
  },
  planStep: {
    flexDirection: "row",
    gap: 12,
    marginTop: 12,
    backgroundColor: palette.bg,
    borderRadius: 16,
    padding: 12,
    borderWidth: 1,
    borderColor: palette.lineSoft,
    alignItems: "flex-start",
  },
  planStepIndex: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: palette.orange,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 2,
  },
  planStepIndexText: {
    color: "#FFFFFF",
    fontWeight: "800",
    fontSize: 13,
  },
  planStepBody: {
    flex: 1,
  },
  planStepLabel: {
    fontSize: 11,
    fontWeight: "800",
    color: palette.orange,
    letterSpacing: 1,
  },
  planStepTitle: {
    marginTop: 3,
    fontSize: 16,
    fontWeight: "800",
    color: palette.ink,
  },
  planStepNote: {
    marginTop: 3,
    fontSize: 13,
    lineHeight: 18,
    color: palette.sub,
  },
  planStepMeta: {
    marginTop: 4,
    fontSize: 12,
    color: palette.faint,
  },
  planStepImage: {
    width: 64,
    height: 64,
    borderRadius: 12,
    backgroundColor: palette.tint,
    overflow: "hidden",
  },
  preTripChecklist: {
    marginTop: 14,
    borderRadius: 16,
    padding: 14,
    backgroundColor: palette.bg,
    borderWidth: 1,
    borderColor: palette.lineSoft,
    gap: 8,
  },
  preTripTitle: {
    fontSize: 14,
    fontWeight: "800",
    color: palette.ink,
  },
  preTripRow: {
    flexDirection: "row",
    gap: 8,
    alignItems: "flex-start",
  },
  preTripMark: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: palette.orange,
    color: "#FFFFFF",
    fontWeight: "800",
    fontSize: 12,
    textAlign: "center",
    lineHeight: 20,
    flexShrink: 0,
    overflow: "hidden",
  },
  preTripText: {
    flex: 1,
    fontSize: 13,
    lineHeight: 19,
    color: palette.sub,
  },

  // --- Floating / Tab bar ---
  floating: {
    alignItems: "center",
    gap: 10,
    paddingHorizontal: 16,
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: palette.surface,
    borderTopWidth: 1,
    borderTopColor: palette.line,
  },
  bannerDock: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: palette.surface,
    borderTopWidth: 1,
    borderTopColor: palette.line,
  },
  bannerInline: {
    marginTop: 24,
    alignItems: "center",
    justifyContent: "center",
  },
  spotsLink: {
    marginTop: 10,
    // 文字だけのリンクは高さが19pxしかなく、指で押すには小さすぎた
    // (WCAG 2.2 のターゲットサイズ最小 24px を下回る)。上下に余白を足して押せる高さにする。
    paddingVertical: 10,
    textAlign: "center",
    fontSize: 13,
    lineHeight: 20,
    fontWeight: "700",
    color: palette.orangeDark,
    textDecorationLine: "underline",
  },
  siteShare: {
    marginTop: 14,
    alignItems: "center",
  },
  siteShareLabel: {
    fontSize: 12,
    lineHeight: 18,
    color: palette.faint,
    textAlign: "center",
  },
  siteShareLinks: {
    marginTop: 6,
    flexDirection: "row",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  siteShareLink: {
    marginHorizontal: 6,
    // spotsLink と同じ理由。文字だけのリンクは指で押すには低すぎるので上下に余白を足す。
    paddingVertical: 10,
    paddingHorizontal: 4,
    fontSize: 13,
    lineHeight: 20,
    fontWeight: "700",
    color: palette.orangeDark,
    textDecorationLine: "underline",
  },
  webFooter: {
    marginTop: 28,
    paddingTop: 18,
    paddingBottom: 8,
    borderTopWidth: 1,
    borderTopColor: palette.line,
    alignItems: "center",
  },
  webFooterLinks: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: 4,
  },
  webFooterLink: {
    // タップ領域を44px前後に確保する(文字は小さくても押しやすく)
    paddingVertical: 12,
    paddingHorizontal: 10,
    fontSize: 12,
    fontWeight: "700",
    color: palette.sub,
    textDecorationLine: "underline",
  },
  webFooterCopy: {
    marginTop: 6,
    fontSize: 11,
    color: palette.faint,
  },
  subBtn: {
    width: "100%",
    maxWidth: 320,
    minHeight: 50,
    borderRadius: 999,
    borderWidth: 1.5,
    borderColor: palette.orange,
    backgroundColor: palette.surface,
    alignItems: "center",
    justifyContent: "center",
  },
  subBtnText: { color: palette.orangeDark, fontWeight: "800", fontSize: 15 },
  tabBar: {
    flexDirection: "row",
    backgroundColor: palette.surface,
    borderTopWidth: 1,
    borderTopColor: palette.line,
    paddingBottom: 6,
    paddingTop: 4,
  },
  tabItem: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    gap: 3,
    paddingVertical: 6,
  },
  tabActiveBar: {
    position: "absolute",
    top: 0,
    width: 44,
    height: 3,
    borderRadius: 999,
    backgroundColor: palette.orange,
  },
  tabLabel: { fontSize: 11, fontWeight: "700", color: palette.sub },
  tabLabelActive: { color: palette.orange, fontWeight: "800" },
});
